import { render, staticRenderFns } from "./BigCrunchButton.vue?vue&type=template&id=2d1de0f8&scoped=true&"
import script from "./BigCrunchButton.vue?vue&type=script&lang=js&"
export * from "./BigCrunchButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1de0f8",
  null
  
)

export default component.exports